import { ProductBadgeData } from "../types/productBadges.type";

export class ProductBadgesTransformer {
  static optionsTransformer() {
    return (productBadges: ProductBadgeData[]) => {
      return productBadges.map((productBadge) => {
        return {
          label:
            <div className="flex items-center gap-2">
              <img src={productBadge?.icon?.url} className="max-w-6 max-h-6" />
              {productBadge.display_name}
            </div>,
          value: productBadge.id
        }
      })
    }
  }
}
